<style lang="scss" scoped>
    .shop-single-item__select-box {
        max-width: 100%;
    }
    .double-input-select__field-gr select {
        color: #1a1a1a;
    }
</style>

<style lang="scss">
    @media (min-width: 1400px) {
        .shop-single-item__col-1 {
            max-width: 100%;
        }
    }
    @media (min-width: 1200px) and (max-width: 1399px) {
        .shop-single-item__col-1 {
            max-width: 100%;
        }
    }
    .d-xxl-block {
        display: none;
    }
    @media (min-width: 1400px) {
        .d-xxl-block {
            display: block !important;
        }
    }

    @media (max-width: 767px) {
        .shop-single-item__image .after-bg {
            &:after {
                display: none;
            }
            img {
                &.visita {
                    margin: 0 auto;
                    width: 100%;
                    max-width: 100%;
                    object-fit: cover;
                }
            }
        }
    }

    .wine-shop-item__image {
        &.no-after {
            &:after {
                display: none !important;
            }
            img {
                margin: 0 auto;
                width: 100%;
                max-width: 100%;
                @media (max-height: 992px) {
                    max-height: 200px;
                }
                object-fit: cover;
            }
        }
    }

    .double-input__field-gr .vfc-single-input {
        border-radius: 0px;
        text-align: left;
        color: #1a1a1a;
    }
    .placeholder-triggered {
        transform: translate(0px, -22px);
        font-size: 80%;
    }
    .vfc-top-date {
        margin: 12px 25px;
        font-size: 16px;
        font-weight: normal;
        text-transform: uppercase;
        font-weight: bold;
    }
    .vfc-navigation-buttons div .vfc-arrow-left,
    .vfc-separately-navigation-buttons div .vfc-arrow-left,
    .vfc-navigation-buttons div .vfc-arrow-right,
    .vfc-separately-navigation-buttons div .vfc-arrow-right {
        width: 8px;
        height: 8px;
        border-color: #0a0c19;
        margin: 11px 15px;
    }
    .vfc-week .vfc-day span.vfc-span-day {
        font-size: 14px;
    }
    .vfc-dayNames span {
        margin-top: 4px;
    }
    .vfc-calendars-container {
        width: 100%;
    }
    .vfc-main-container.vfc-modal {
        width: 100%;
        max-width: 330px;
        top: calc(100% - 1px);
        min-width: 270px;
    }
    .vfc-main-container {
        border-radius: 0 !important;
    }
    .vfc-main-container {
        position: relative;
        border-radius: 0 !important;
        box-shadow: 0 2px 20px 3px rgba(0, 0, 0, 0.09);
        font-family: "europa", sans-serif;
        background-color: #ffffff;
        user-select: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid #d8d8d8;
    }
    .vfc-week .vfc-day span.vfc-span-day.vfc-today {
        background-color: #dccdb1 !important;
        color: #ffffff;
    }
    .vfc-week .vfc-day span.vfc-span-day.vfc-marked {
        background-color: #b6975c;
    }
    .vfc-content {
        margin: 0 11px;
    }
    .vfc-week .vfc-day span.vfc-span-day.vfc-hover:hover,
    .vfc-week .vfc-day span.vfc-span-day.vfc-hovered {
        background-color: #b6975c;
        color: #ffffff;
    }
</style>

<template>
    <div>
        <div class="mt-4 pt-3 pt-md-0 mt-md-n2 mb-4 pb-2 mb-md-0 pb-md-0" v-if="product.combinations[0].perks">
            <div class="compact-item__list dot-styled-list" v-for="(perk, index) in product.combinations[0].perks[lang]" :key="index">
                <div class="dot-styled-list__dot-image"></div>
                <div class="dot-styled-list__text">
                    <p>{{ perk }}</p>
                </div>
            </div>
        </div>

        <div class="position-relative" v-if="product.available_for_order">
            <div class="shop-single-item__price price-style mt-4 mb-2 mb-md-4">
                <span>€</span> <span>{{ price }}</span>
                <span v-if="lang == 'it'"> a persona</span>
                <span v-else> per person</span>
            </div>

            <div v-if="product.type != 'eventi'" class="d-flex w-100 flex-column product-selects mt-2">
                <div v-if="typeof formats != 'undefined' && formats.length > 0" class="shop-single-item__select-box mb-2">
                    <select class="shop-type-select" @change="selectFormat($event.target.value)">
                        <option v-for="(format, index) in formats" :key="index" :value="format.value" v-text="$root.translateString('duration') + ': ' + format.name" :selected="selected_format == format.value"></option>
                    </select>
                </div>
            </div>

            <!-- -->

            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row" :class="{ 'pt-4': formats.length > 0 }">
                <div v-if="product.type != 'eventi'" class="double-input__field-gr double-input__field-gr--less-space-between">
                    <label class="full-input__after-input" :class="{ 'placeholder-triggered': is_date_filled }">
                        {{ $root.translateString("date") }}
                    </label>
                    <FunctionalCalendar
                        v-if="calendar_on"
                        :count="counter"
                        @dayClicked="dayClicked"
                        ref="calendar"
                        :day-names="dayNames"
                        :month-names="monthNames"
                        :short-month-names="shortMonthNames"
                        :disabledDates="['beforeToday', today]"
                        :isAutoCloseable="true"
                        :is-modal="true"
                        :date-format="'dd/mm/yyyy'"
                        placeholder=""
                        :is-date-picker="true"
                        v-model="visit.date"></FunctionalCalendar>
                    <div class="invalid-feedback" :class="{ 'd-block': validation.visit.date.state == false }">{{ validation.visit.date.message }}</div>
                </div>
                <div v-else class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                    <div class="full-input__field-gr">
                        <select name="adults" id="adults" required v-model="visit.adults">
                            <option value="1">1 {{ $root.translateString("participant") }}</option>
                            <option value="2" selected>2 {{ $root.translateString("participants") }}</option>
                            <option value="3">3 {{ $root.translateString("participants") }}</option>
                            <option value="4">4 {{ $root.translateString("participants") }}</option>
                            <option value="5">5 {{ $root.translateString("participants") }}</option>
                            <option value="6">6 {{ $root.translateString("participants") }}</option>
                        </select>
                    </div>
                </div>
                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                    <input placeholder=" " data-lpignore="true" type="text" @focus="validation.visit.name.state = null" v-model="visit.name" />
                    <div class="invalid-feedback" :class="{ 'd-block': validation.visit.name.state == false }">{{ validation.visit.name.message }}</div>
                    <label class="full-input__after-input">
                        {{ $root.translateString("name") }}
                    </label>
                </div>
            </div>

            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row pt-sm-4 pt-md-0 pt-lg-4">
                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                    <div class="full-input__field-gr">
                        <input placeholder=" " data-lpignore="true" type="text" @focus="validation.visit.email.state = null" v-model="visit.email" />
                        <div class="invalid-feedback" :class="{ 'd-block': validation.visit.email.state == false }">{{ validation.visit.email.message }}</div>
                        <label class="full-input__after-input"> Email </label>
                    </div>
                </div>
                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                    <input placeholder=" " data-lpignore="true" type="text" @focus="validation.visit.phone.state = null" v-model="visit.phone" />
                    <div class="invalid-feedback" :class="{ 'd-block': validation.visit.phone.state == false }">{{ validation.visit.phone.message }}</div>
                    <label class="full-input__after-input">
                        {{ $root.translateString("phone") }}
                    </label>
                </div>
            </div>

            <div v-if="product.type != 'eventi'" class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row pt-sm-4 pt-md-0 pt-lg-4">
                <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                    <div class="full-input__field-gr">
                        <select name="adults" id="adults" required v-model="visit.adults">
                            <option value="1">1 {{ $root.translateString("adult") }}</option>
                            <option value="2" selected>2 {{ $root.translateString("adults") }}</option>
                            <option value="3">3 {{ $root.translateString("adults") }}</option>
                            <option value="4">4 {{ $root.translateString("adults") }}</option>
                            <option value="5">5 {{ $root.translateString("adults") }}</option>
                            <option value="6">6 {{ $root.translateString("adults") }}</option>
                        </select>
                    </div>
                </div>
                <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                    <div class="full-input__field-gr">
                        <select name="kids" id="kids" required v-model="visit.kids">
                            <option value="0" selected>{{ $root.translateString("no-kids") }}</option>
                            <option value="1">1 {{ $root.translateString("kid") }}</option>
                            <option value="2">2 {{ $root.translateString("kids") }}</option>
                            <option value="3">3 {{ $root.translateString("kids") }}</option>
                            <option value="4">4 {{ $root.translateString("kids") }}</option>
                            <option value="5">5 {{ $root.translateString("kids") }}</option>
                            <option value="6">6 {{ $root.translateString("kids") }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="pt-0 pt-sm-4 mt-2">
                <p class="shop-single-item__text" v-if="lang == 'it'">Scopri le nostre <a target="_blank" class="text-gold" href="/it/norme-di-sicurezza">norme di sicurezza</a> per l'emergenza COVID-19.</p>
                <p class="shop-single-item__text" v-else>Read our <a target="_blank" class="text-gold" href="/it/safety-policy">security measures</a> for COVID-19 emergency.</p>
            </div>

            <!-- -->

            <div class="shop-single-item__add-to-cart mt-0 mt-lg-4 d-767-none mb-4 pb-2" v-if="isBuyableByGuest">
                <!--<div class="shop-single-item__add-quantity quantity-btns">
                    <div class="quantity-btns__minus">
                        <img @click="buy.qty > 1 ? buy.qty-- : 1" src="/images/svg/roeno-04.svg" alt="icona" />
                    </div>

                    <div class="quantity-btns__input">
                        <input readonly type="number" min="1" v-model="buy.qty" />
                    </div>

                    <div class="quantity-btns__plus">
                        <img @click="buy.qty < 10 ? buy.qty++ : 10" src="/images/svg/roeno-05.svg" alt="icona" />
                    </div>
                </div>-->

                <div class="shop-single-item__add-btn ml-0 mt-3 mt-lg-4">
                    <div class="brand-btn">
                        <a @click="addToCart" class="full" href="javascript:void(0)"
                            ><span>{{ $root.translateString("add_to_cart") }}</span></a
                        >
                    </div>
                </div>
            </div>
            <div class="shop-single-item__add-to-cart mb-4 mt-4 mt-md-0" v-else>
                <div class="small-banner d-flex align-items-center p-3 mt-n4 bg-white">
                    <h6 class="flex-grow-1 font-serif text-bigger d-flex flex-column" style="line-height: 1.1" v-if="lang == 'it'">
                        Per poter acquistare quest'annata devi essere iscritto al nostro Wine Club. Iscriviti ora, è semplice e completamente gratuito: potrai accedere ad annate, visite esclusive e tanto altro ancora!
                        <a class="text-gold w-100 mt-3" href="javascript:void(0)" @click="summonPopup">Iscriviti al Wine Club</a>
                    </h6>
                    <h6 class="flex-grow-1 font-serif text-bigger d-flex flex-column" style="line-height: 1.1" v-else>
                        To be able to buy this vintage you must be registered in our Wine Club. Sign up now, it's simple and completely free: you will be able to access vintages, exclusive visits and much more!
                        <a class="text-gold w-100 mt-3" href="javascript:void(0)" @click="summonPopup"> Join the Wine Club </a>
                    </h6>
                </div>
            </div>

            <div class="shop-single-item__add-btn mt-5 d-768-none" v-if="isBuyableByGuest">
                <div class="brand-btn">
                    <a @click="addToCart" class="full" href="javascript:void(0)"
                        ><span>{{ $root.translateString("add_to_cart") }}</span></a
                    >
                </div>
            </div>

            <p class="added-to-cart mt-3 d-inline-block text-center w-100" v-if="added_to_cart">
                <span>{{ $root.translateString("added_to_cart") }}</span>
            </p>
        </div>

        <div class="position-relative" v-else>
            <div class="prodotto-quantity no-before">
                <p class="mb-4 text-center text-lg-left w-100">- {{ $root.translateString("not_available") }} -</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { FunctionalCalendar } from "vue-functional-calendar";
    export default {
        components: {
            FunctionalCalendar,
        },
        props: ["productProp", "qsFormat", "qsYear", "qsAdwordsProp", "lang", "isLogged"],
        data() {
            return {
                main_selector: "formato",
                default_format: "",
                selected_code: "",
                selected_format: "",
                product: null,
                is_logged: false,
                combinations: {},
                formats: [],
                buy: {
                    type: "product",
                    id: null,
                    qty: 1,
                },
                added_to_cart: false,
                socialProductId: "",
                validation: {
                    visit: {
                        lang: {
                            state: null,
                            message: "",
                        },
                        date: {
                            state: null,
                            message: "",
                        },
                        name: {
                            state: null,
                            message: "",
                        },
                        email: {
                            state: null,
                            message: "",
                        },
                        phone: {
                            state: null,
                            message: "",
                        },
                    },
                },
                visit: {
                    lang: "it",
                    date: {},
                    name: "",
                    email: "",
                    phone: "",
                    adults: 2,
                    kids: 0,
                },
                calendarData: {},
                errors: {},
                dayNames: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                shortMonthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                calendar_on: false,
                today: null,
                is_date_filled: false,
                counter: 0,
            };
        },
        created() {
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            this.today = dd + "/" + mm + "/" + yyyy;

            //

            if (this.lang == "it") {
                this.dayNames = ["Lu", "Ma", "Me", "Gi", "Ve", "Sa", "Do"];
                this.monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
                this.shortMonthNames = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
            }

            this.product = this.productProp;

            if (this.isLogged) {
                this.is_logged = true;
            }

            this.default_format = this.product.combinations[0].code;
            this.main_selector = this.product.combinations[0].code;

            this.product.combinations.sort(function (a, b) {
                return parseFloat(a.price) - parseFloat(b.price);
            });

            this.buy.id = this.product.id;

            let tmp_first_format = "";
            let default_format_exist = false;
            let tmp_formats = [];

            for (let [key, combination] of Object.entries(this.product.combinations)) {
                let weight = 1;

                if (typeof combination.weight != "undefined") {
                    weight = parseFloat(combination.weight);
                }

                this.combinations[combination.code] = {
                    code: combination.code,
                    price: combination.price,
                    weight: weight,
                    attributes: {},
                };

                if (this.product.combinations.length == 1) {
                    //variant for visits without combinations
                    this.selected_format = combination.code;
                }

                if (combination.attributes.length > 0) {
                    for (let attribute of combination.attributes) {
                        this.combinations[combination.code].attributes[attribute.key] = attribute;

                        if (attribute.key == "formato" && !tmp_formats.includes(attribute.value)) {
                            if (key == 0) {
                                tmp_first_format = attribute.value;
                            }

                            if (attribute.value == this.default_format) {
                                default_format_exist = true;
                            }

                            tmp_formats.push(attribute.value);

                            let name = attribute.value_label;

                            if (this.lang == "en") {
                                if (name.indexOf("pax") > -1) {
                                    name = name.split(" - ")[0] + " -  cold cuts included (+10€ pax)";
                                } else {
                                    name = name.split(" - ")[0] + " -  without cold cuts";
                                }
                            }

                            this.formats.push({
                                value: attribute.value,
                                name: name,
                                combination: combination.code,
                            });

                            this.selected_format = this.formats[0].combination;
                        }
                    }
                }
            }
        },
        mounted() {
            this.socialProductId = this.product.id + "_" + this.product.link_rewrite + "_";
            if (this.selected_code != null) {
                this.socialProductId += this.selected_code;
            }

            this.calendar_on = true;

            fbq("track", "ViewContent", {
                value: parseFloat(this.price),
                currency: "EUR",
                content_ids: this.socialProductId,
                content_type: "product",
                content_name: this.product.name,
            });

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    items: [
                        {
                            item_name: this.product.name.replace("<br>", " "),
                            item_id: this.socialProductId,
                            price: this.$root.currencyDisplayGtm(this.price),
                            item_brand: "Cantina Roeno",
                            item_category: this.type,
                            item_variant: this.selected_format,
                            quantity: 1,
                        },
                    ],
                },
            });
        },
        methods: {
            dayClicked() {
                this.is_date_filled = true;
            },
            canProceed() {
                let is_invalid = false;

                Object.keys(this.validation.visit).forEach((elem, key) => {
                    this.validation.visit[elem].message = "";
                    this.validation.visit[elem].state = null;
                });

                if (Object.keys(this.visit.date).length == 0 && this.product.type != "eventi") {
                    if (this.lang == "it") {
                        this.validation.visit.date.message = "Questo campo non può essere vuoto.";
                    } else {
                        this.validation.visit.date.message = "This field cannot be empty.";
                    }
                    this.validation.visit.date.state = false;
                    is_invalid = true;
                } else {
                    this.validation.visit.date.state = null;
                }

                if (this.visit.name == "") {
                    if (this.lang == "it") {
                        this.validation.visit.name.message = "Questo campo non può essere vuoto.";
                    } else {
                        this.validation.visit.name.message = "This field cannot be empty.";
                    }
                    this.validation.visit.name.state = false;
                    is_invalid = true;
                } else {
                    this.validation.visit.name.state = null;
                }

                if (this.visit.phone == "") {
                    if (this.lang == "it") {
                        this.validation.visit.phone.message = "Questo campo non può essere vuoto.";
                    } else {
                        this.validation.visit.phone.message = "This field cannot be empty.";
                    }
                    this.validation.visit.phone.state = false;
                    is_invalid = true;
                } else {
                    this.validation.visit.phone.state = null;
                }

                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let disposable = require("is-disposable-email");
                if (!re.test(this.visit.email)) {
                    if (this.lang == "it") {
                        this.validation.visit.email.message = "Non sembra un indirizzo email valido.";
                    } else {
                        this.validation.visit.email.message = "The email address is invalid.";
                    }
                    this.validation.visit.email.state = false;
                    is_invalid = true;
                } else {
                    if (disposable(this.visit.email)) {
                        if (this.lang == "it") {
                            this.validation.visit.email.message = "Tipologia di servizio email non valido.";
                        } else {
                            this.validation.visit.email.message = "You email provider is invalid.";
                        }
                        this.validation.visit.email.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.visit.email.state = null;
                    }
                }

                if (is_invalid) {
                    setTimeout(() => {
                        let elements = document.querySelectorAll(".invalid-feedback");

                        window.scroll({
                            top: parseInt(elements[0].getBoundingClientRect().top + window.scrollY) - 150,
                            behavior: "smooth",
                        });
                    }, 500);

                    return false;
                }

                return true;
            },
            summonPopup() {
                this.$eventHub.$emit("register", {});
            },
            selectFormat(format) {
                if (this.main_selector == "formato") {
                    for (let [k, c] of Object.entries(this.combinations)) {
                        if (c.attributes.formato.value == format) {
                            this.selected_code = c.code;
                        }
                    }
                } else {
                    this.formats.forEach((y) => {
                        if (y.value == format) {
                            this.selected_code = y.combination;
                        }
                    });
                }
                this.selected_format = format;
            },
            addToCart() {
                if (this.canProceed()) {
                    this.buy.id = this.product.id;
                    this.buy.combination = this.combinations[this.selected_code];
                    this.buy.qty = this.visit.adults;
                    this.buy.visit = this.visit;

                    axios
                        .post("/api/cart/add", this.buy)
                        .then((response) => {
                            if (response.data.status === true) {
                                fbq("track", "AddToCart", {
                                    value: parseFloat(this.price),
                                    currency: "EUR",
                                    contents: [
                                        {
                                            id: this.product.name,
                                            quantity: this.buy.qty,
                                        },
                                    ],
                                    content_type: "product",
                                    content_name: this.product.name,
                                });

                                dataLayer.push({ ecommerce: null });
                                dataLayer.push({
                                    event: "add_to_cart",
                                    ecommerce: {
                                        items: [
                                            {
                                                item_name: this.product.name.replace("<br>", " "),
                                                item_id: this.socialProductId,
                                                price: this.$root.currencyDisplayGtm(this.price),
                                                item_brand: "Cantina Roeno",
                                                item_category: this.type,
                                                item_variant: this.selected_format,
                                                quantity: this.buy.qty,
                                            },
                                        ],
                                    },
                                });

                                let buy_qty_memo = this.buy.qty;
                                this.$eventHub.$emit("cart.added", {
                                    count: response.data.count,
                                    specific_count: buy_qty_memo,
                                    product_id: this.product.id,
                                    product_code: this.selected_code,
                                });

                                if ($(window).width() >= 992) {
                                    this.$eventHub.$emit("cart.show", {});
                                }

                                Object.keys(this.validation.visit).forEach((elem, key) => {
                                    this.validation.visit[elem].message = "";
                                    this.validation.visit[elem].state = null;
                                });

                                this.added_to_cart = true;
                                this.buy.qty = 1;
                                this.resetVisitForm();
                                this.buy.combination = null;
                                this.buy.id = null;
                                this.buy.visit = {};
                                this.is_date_filled = false;
                                this.selectFormat(this.default_format);

                                this.calendar_on = false;
                                setTimeout(() => {
                                    this.calendar_on = true;
                                }, 200);

                                setTimeout(() => {
                                    this.added_to_cart = false;
                                }, 4000);
                            }
                        })
                        .catch((err) => {
                            //console.log('Error');
                        });
                } else {
                }
            },
            resetVisitForm() {
                this.visit = {};

                this.visit.lang = "it";
                this.visit.date = {};
                this.visit.name = "";
                this.visit.email = "";
                this.visit.phone = "";
                this.visit.adults = 2;
                this.visit.kids = 0;
            },
        },
        computed: {
            isBuyableByGuest() {
                return true;
            },
            price() {
                if (this.selected_code == "") this.selected_code = this.selected_format;
                let base = this.combinations[this.selected_code].price;

                //let qty = this.buy.qty; disabled for now
                let qty = 1;

                return this.$root.currencyDisplaySimple(base * qty);
            },
        },
    };
</script>
